export default __webpack_public_path__ + "static/media/teams.87f268bc.png";